import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { CONTACT, CREDENTIALS } from '../data/site';
export function AboutCoach() {
  return <section id="coach" className="w-full bg-ink py-16 sm:py-24" data-id="element-16" data-mp="nyui3gyggozp">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-17" data-mp="nzm2dvmlr0ao">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-18" data-mp="sy782akmic6i">
          <motion.div initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.5
        }} className="relative mx-auto w-full max-w-sm lg:mx-0 lg:max-w-none" data-id="element-19" data-mp="3rft807okv7m3">
            <div className="rounded-[10px] bg-gradient-to-br from-brand-orange to-brand-red p-[2px] shadow-2xl shadow-brand-red/20" data-id="element-20" data-mp="9yt91e81eb95">
              <img src={CONTACT.coachPortrait} alt="Coach Leonard Leal on the pitch at Juniper Valley Park" className="w-full rounded-[8px] object-cover object-top aspect-[3/4] sm:aspect-[4/5]" loading="lazy" data-id="element-21" data-mp="38o0ca5i4j8ao" />
            </div>
            <div className="absolute -bottom-5 left-4 rounded-2xl bg-gradient-to-r from-brand-orange to-brand-red px-5 py-4 shadow-xl shadow-brand-red/30 sm:left-6" data-id="element-22" data-mp="6hawnyo1l61s">
              <span className="block font-display text-2xl leading-none" data-id="element-23" data-mp="3sw43rqpg56hn">FIFA</span>
              <span className="block text-[11px] font-semibold uppercase tracking-[0.18em] text-white/90" data-id="element-24" data-mp="3otz9qqv367uh">
                Registered Coach
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.5,
          delay: 0.08
        }} data-id="element-25" data-mp="3evjkktfmd8nm">
            <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-brand-orange" data-id="element-26" data-mp="1d3dkm0o21zp9">
              Meet your coach
            </span>
            <h2 className="mt-3 text-3xl uppercase sm:text-4xl" data-id="element-27" data-mp="183isjtsjn42m">Coach Leonard Leal</h2>
            <p className="mt-4 text-white/75" data-id="element-28" data-mp="32jh6gcbna1mh">
              Leonard Leal is a FIFA Registered Coach and an International Coach with licenses from
              Venezuela and the USA. As a former National University League Soccer Player with
              coaching experience in the UPSL, he has spent his career inside competitive dressing
              rooms — and now brings that same standard to youth players in Queens.
            </p>
            <p className="mt-4 text-white/75" data-id="element-29" data-mp="3qbo9tvfsf8ve">
              Every session is built around real development: technical repetition, decision-making
              under pressure, and the habits that separate players who train from players who
              compete.
            </p>

            <figure className="mt-7 rounded-2xl border border-ink-line bg-ink-card p-6" data-id="element-30" data-mp="20w82mllfbx85">
              <QuoteIcon className="h-6 w-6 text-brand-orange" aria-hidden="true" data-id="element-31" data-mp="20ykrlipln7up" />
              <blockquote className="mt-3 font-display text-lg uppercase leading-snug sm:text-xl" data-id="element-32" data-mp="24vp6xbp46obq">
                Developing discipline, technique, and passion in the next generation of players.
              </blockquote>
              <figcaption className="mt-3 text-sm text-white/50" data-id="element-33" data-mp="27cgit9y1ffti">
                Leonard Leal — Founder & Head Coach
              </figcaption>
            </figure>

            <dl className="mt-7 grid gap-3 sm:grid-cols-3" data-id="element-34" data-mp="22e5a52jhbbcv">
              {CREDENTIALS.map(item => <div key={item.label} className="rounded-xl border border-ink-line bg-ink-soft px-4 py-3" data-id="element-35" data-mp="1eo2p36dzf5nr">
                  <dt className="text-sm font-bold" data-id="element-36" data-mp="1oent59cfd2e2">{item.label}</dt>
                  <dd className="text-xs text-white/55" data-id="element-37" data-mp="1jn5rsk6hozsk">{item.detail}</dd>
                </div>)}
            </dl>
          </motion.div>
        </div>
      </div>
    </section>;
}